<div class="row">
  <div class="col-md-1"></div>
  <div class="col-md-10">
    <h1 class="text-capitalize text-center" jhiTranslate="hi-robot.title">Title</h1>
    <hr />
    <p class="text-justify text-center" jhiTranslate="hi-robot.content">Content</p>
  </div>
  <div class="col-md-1"></div>
</div>
